(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smid-design-page-contact"] && !Shopify.designMode) return;
  try {
    
  function initSmidDesignContact(root = document) {
    const params = new URLSearchParams(location.search);
    root.querySelectorAll('.sd-native-contact').forEach((form) => {
      if (form.dataset.sdInitialized) return;
      form.dataset.sdInitialized = 'true';
      form.querySelector('.sd-form-status, .sd-form-errors')?.focus({preventScroll: false});
      for (const [selector, key] of [['[data-sd-solution]', 'oplossing'], ['[data-sd-brand]', 'merk']]) {
        const field = form.querySelector(selector);
        const value = params.get(key);
        if (field && value && [...field.options].some((option) => option.value === value)) field.value = value;
      }
    });
  }
  initSmidDesignContact();
  document.addEventListener('shopify:section:load', (event) => initSmidDesignContact(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smid-premium-home"] && !Shopify.designMode) return;
  try {
    
  function initializeSmidPremiumHomepage(root) {
    if (!root || root.dataset.spxInitialized === 'true') return;
    root.dataset.spxInitialized = 'true';
    root.classList.add('spx-motion');

    const tabRoot = root.querySelector('[data-spx-tabs]');
    if (tabRoot) {
      const tabs = [...tabRoot.querySelectorAll('[data-spx-tab]')];
      const panels = [...tabRoot.querySelectorAll('[data-spx-panel]')];
      const activateTab = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.spxPanel !== tab.dataset.spxTab; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex !== index) {
            event.preventDefault();
            activateTab(tabs[nextIndex]);
            tabs[nextIndex].focus();
          }
        });
      });
    }

    const reveals = [...root.querySelectorAll('.spx-reveal')];
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach((element) => element.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px' });
    reveals.forEach((element) => observer.observe(element));
  }

  document.querySelectorAll('[data-spx-home]').forEach(initializeSmidPremiumHomepage);
  document.addEventListener('shopify:section:load', (event) => initializeSmidPremiumHomepage(event.target.querySelector('[data-spx-home]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smid-v3-home"] && !Shopify.designMode) return;
  try {
    
  function initializeSmidHomepage(root) {
    if (!root || root.dataset.spkInitialized === 'true') return;
    root.dataset.spkInitialized = 'true';
    const tabRoot = root.querySelector('[data-spk-tabs]');
    if (!tabRoot) return;
    const buttons = [...tabRoot.querySelectorAll('[data-spk-tab]')];
    const panels = [...tabRoot.querySelectorAll('[data-spk-panel]')];
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.spkTab;
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.spkPanel !== target; });
      });
    });
  }
  document.querySelectorAll('[data-spk-home]').forEach(initializeSmidHomepage);
  document.addEventListener('shopify:section:load', (event) => { initializeSmidHomepage(event.target.querySelector('[data-spk-home]')); });

  } catch(e) { console.error(e); }
})();
})();
